const UUID_RE = /^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$/i;

export interface VendorLinkFields {
    vendorSlug?: string | null;
    vendorUserId?: string | null;
    vendorName?: string | null;
}

export function isUuidLike(value: string | null | undefined): boolean {
    return !!value && UUID_RE.test(value);
}

/** URL path segment for `/user/{segment}/...` — prefers username, falls back to owner id. */
export function vendorPathSegment(item: VendorLinkFields): string | null {
    if (item.vendorSlug && !isUuidLike(item.vendorSlug)) return item.vendorSlug;
    if (item.vendorUserId) return item.vendorUserId;
    if (item.vendorSlug) return item.vendorSlug;
    return null;
}

/** Human-readable seller label — never returns a raw UUID. */
export function vendorDisplayLabel(item: VendorLinkFields, fallback = "Seller"): string | null {
    if (item.vendorName?.trim()) return item.vendorName.trim();
    if (item.vendorSlug && !isUuidLike(item.vendorSlug)) return item.vendorSlug;
    return null;
}

export function vendorProfileHref(item: VendorLinkFields): string | null {
    const segment = vendorPathSegment(item);
    return segment ? `/user/${segment}` : null;
}

export function vendorPageHref(item: VendorLinkFields & { pageSlug?: string | null }): string | null {
    const segment = vendorPathSegment(item);
    if (!segment || !item.pageSlug) return null;
    return `/user/${segment}/pages/${item.pageSlug}`;
}
